import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 16v-8","key":"svg-0"}],["path",{"d":"M11 8v8","key":"svg-1"}],["path",{"d":"M7 12h4","key":"svg-2"}],["path",{"d":"M14 12h4","key":"svg-3"}],["path",{"d":"M16 10v4","key":"svg-4"}]]

const IconSignalHPlus = createReactComponent('outline', 'signal-h-plus', 'SignalHPlus', __iconNode);

export default IconSignalHPlus;